import React from 'react'
import './ErrorNoFound.css'
export const ErrorNoFound = () => {
  return (
    <div className='bodyNottFound '>
      <div className='centrador'><img src="https://img.freepik.com/free-vector/404-error-with-landscape-concept-illustration_114360-7898.jpg?w=1380&t=st=1683531626~exp=1683532226~hmac=9fcde4df4060cb07a994530571b1dc30840658d0eea1fcf62527d05cd0531511" /></div>
      <div className='centrador'>
        <h2 className='descripcion-servicio'>¡Vaya! Parece que has llegado a un lugar que no existe. No te preocupes, incluso los mejores exploradores se pierden a veces. Vuelve a la página principal y sigue explorando, seguro que encontrarás algo genial.</h2>
      </div>
    </div>
  )
}
